import React, { createContext, useMemo, useReducer } from "react";

const ResponseStatus = {
    IDLE: "idle",
    PENDING: "pending",
    RESOLVED: "resolved",
    ERROR: "error"
}

const StatusContextData = createContext({
    messageQueue: [],
})

const StatusContextApi = createContext({
    addMessage: () => {
    },
    removeMessage: () => {
    }
})

const reducer = (state, action) => {
    switch(action.type){
        case "add":
            state[action.id] = action.newValue;
            break;
        case "remove":
            delete state[action.id];
            break;
    }
    return {...state};
};

function StatusProvider({children}) {
    const [messages, dispatch] = useReducer(reducer, {});



    const api = useMemo(() => {
        const removeMessage = (id) => {
            dispatch({type: "remove", id: id});
        };

        const addMessage = (type, duration, content) => {
            let id = new Date().getTime() + "" + Object.values(messages).length;
            let message = {
                type: type,
                duration: duration,
                content: content,
            }
            if (duration > 0) {
                setTimeout(removeMessage, duration, id);
            }
            dispatch({type:"add", id:id, newValue: message});
            return id;
        }
        return {addMessage, removeMessage}
    }, []);

    const context = {messageQueue: Object.values(messages)}

    return <StatusContextData.Provider value={context}>
        <StatusContextApi.Provider value={api}>
            {children}
        </StatusContextApi.Provider>
    </StatusContextData.Provider>
}

export {StatusContextData, StatusContextApi, StatusProvider, ResponseStatus}